const defaultConfig = {
  appTokenKey: "sj_mall_admin_token", // 集运token key
  mallAppTokenKey: "mall_app_user_key", // 商城token key
  isTbPurchaseOrderMode: "isTbPurchaseOrderMode", // 是否是淘宝采购1688订单
  defaultLocale:"zh-TW",
  layoutCommonConfig: {
    // 商城配置
    header: {
      url: "layout-header",
    },
    footer: {
      url: "layout-footer",
    },
  },
  layoutUserConfig: {
    // 商城配置
    header: {
      url: "layout-user-header",
    },
    footer: {
      url: "layout-user-footer",
    },
  },
  isShowShopSearchBar: true,
  // layoutCommonConfig:{
  //     header:{
  //         url:"site-layout-header",
  //     },
  //     footer:{
  //         url:"site-layout-footer",
  //     }
  // },
  devErpBuySite: false, // 开启erp采购调试
  proxyLinks: {
    // collectionSite:"tmalltesthost:7788",
    // mallSite:"jyshoprelink:8081",
    // qiankunSite:"pc-qiankun-site:7788",
    collectionSite: "http://xjhy.shopmember-test.omszt.com:7888",
    mallSite: "http://api-test.jyshop.omszt.com:8081",
    qiankunSite: "http://xjhy.shopmember-test.omszt.com:7888",
    //  shopSite:"http://api-adminfront.mps.omszt.com:7001",
    shopSite: "http://app-gateway:8897",
    // frontServer:"http://salerfrontserver.mps.omszt.com:7001",
    frontServer: "http://app-front-server:3000",
    //  frontServer:"http://localhost:3001",
    // collectionSite:"MPS-gateway-1:8897",
    // mallSite:"jyshoprelink:8081",
    // qiankunSite:"pc-qiankun-site:7788",
  },
};
export default defaultConfig;
